import Link from 'components/Link';
import React, { FC, memo } from 'react';
import SectionHeading from '../SectionHeading';
import {
  Blocks,
  ButtonArrow,
  Container,
  ConversationList,
  ConversationRow,
  ConversationTitle,
  Description,
  FeedbackCard,
  FeedbackList,
  FeedbackMeta,
  FeedbackThumbnail,
  FeedbackTitle,
  Footer,
  SubBlock,
  SubHeader,
  SubTitle,
  ViewMoreButton,
} from './styles';
import { Props } from './types';

const ConversationsFeedback: FC<Props> = ({ conversations, feedback }) => {
  if (conversations.length === 0 && feedback.length === 0) {
    return null;
  }

  return (
    <Container>
      <SectionHeading title="Conversations & Feedback" />

      <Blocks>
        {conversations.length > 0 && (
          <SubBlock>
            <SubHeader>
              <SubTitle>Keep the community conversation going</SubTitle>
              <Description>
                Check out the most recent community conversations.
              </Description>
            </SubHeader>
            <ConversationList>
              {conversations.map((item) => (
                <ConversationRow key={item.url}>
                  <ConversationTitle>
                    <Link to={item.url}>{item.title}</Link>
                  </ConversationTitle>
                </ConversationRow>
              ))}
            </ConversationList>
            <Footer>
              <ViewMoreButton
                variant="secondary"
                mode="small"
                to="/conversations"
              >
                view more
                <ButtonArrow />
              </ViewMoreButton>
            </Footer>
          </SubBlock>
        )}

        {feedback.length > 0 && (
          <SubBlock>
            <SubHeader>
              <SubTitle>New Feedback requests you can help with</SubTitle>
              <Description>
                Help your fellow members by providing comments on their work.
              </Description>
            </SubHeader>
            <FeedbackList>
              {feedback.map((item) => (
                <FeedbackCard key={item.url}>
                  {item.thumbnail && (
                    <FeedbackThumbnail $src={item.thumbnail} />
                  )}
                  <FeedbackTitle>
                    <Link to={item.url}>{item.title}</Link>
                  </FeedbackTitle>
                  <FeedbackMeta>{item.authorName}</FeedbackMeta>
                </FeedbackCard>
              ))}
            </FeedbackList>
            <Footer>
              <ViewMoreButton variant="secondary" mode="small" to="/feedback">
                view more
                <ButtonArrow />
              </ViewMoreButton>
            </Footer>
          </SubBlock>
        )}
      </Blocks>
    </Container>
  );
};

export default memo(ConversationsFeedback);
